import { gql } from '@/core/shared/api';
import AuthPlugin from '@/core/shared/api/plugins/AuthPlugin';
import TransactionTrackingPlugin from '@/core/shared/api/plugins/TransactionTrackingPlugin';
import CancelPlugin from '@/core/shared/api/plugins/CancelPlugin';
import LocalePlugin from '@/core/shared/api/plugins/LocalePlugin';

let gqlWithoutMiddleware;
let gqlWithMiddleware;

export const configureApiService = store => {
  gqlWithoutMiddleware = gql;
  gqlWithMiddleware = new Proxy(gql, {
    get (obj, target) {
      if (target === 'request' && store.getters.safetyMode) {
        return () => {
          console.log('safety mode return');
          return Promise.resolve();
        };
      }
      return obj[target];
    },
  });
  gql.use(AuthPlugin, { store });
  gql.use(CancelPlugin);
  gql.use(LocalePlugin, { store, localePath: 'launcher.locale' });
  gql.use(TransactionTrackingPlugin);
};

export { gqlWithoutMiddleware, gqlWithMiddleware as gql };
